import { render, staticRenderFns } from "./BatchEditModal.vue?vue&type=template&id=4b2437c4&scoped=true&"
import script from "./BatchEditModal.vue?vue&type=script&lang=js&"
export * from "./BatchEditModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchEditModal.vue?vue&type=style&index=0&id=4b2437c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2437c4",
  null
  
)

export default component.exports